function deepMerge<TResult extends Record<string, unknown> = Record<string, unknown>>(
  ...sources: unknown[]
): TResult {
  let acc: Record<string, unknown> | unknown[] = {};

  for (const source of sources) {
    if (Array.isArray(source)) {
      if (!Array.isArray(acc)) {
        acc = [];
      }
      acc = [...acc, ...source];
    } else if (source instanceof Object) {
      for (const [key, value] of Object.entries(source)) {
        if (value instanceof Object && !Array.isArray(acc) && key in acc) {
          acc = { ...acc, [key]: deepMerge(acc[key], value) };
        } else {
          acc = { ...acc, [key]: value };
        }
      }
    }
  }

  return acc as TResult;
}

export default deepMerge;
